import { render, staticRenderFns } from "./StudentCourseBankAccount.vue?vue&type=template&id=1d7c73fa"
import script from "./StudentCourseBankAccount.vue?vue&type=script&lang=js"
export * from "./StudentCourseBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports